import { Fragment, useRef } from "react";

import styles from "../styles/TextWithSpacesShown.module.scss";

const BULLET = "•";

export const TextWithSpacesShown = ({ text }: { text: string }) => {
  const textRef = useRef<HTMLParagraphElement>(null);

  return (
    <span
      className={styles["text"]}
      onClick={() => {
        if (textRef.current) {
          window.getSelection()?.selectAllChildren(textRef.current);
        }
      }}
      onCopy={e => {
        e.clipboardData.setData("text/plain", text);
        e.preventDefault();
      }}
      onCut={e => {
        e.clipboardData.setData("text/plain", text);
        e.preventDefault();
      }}
      ref={textRef}
    >
      {text.split(" ").map((chunk, index) => (
        <Fragment key={`${chunk}-${index}`}>
          {index === 0 ? null : (
            <span className={styles["bullet"]}>{BULLET}</span>
          )}
          {chunk}
        </Fragment>
      ))}
    </span>
  );
};
